/*
 *
 * VetrinaDigitalePopup
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 04-Feb-2025
 */

import React from 'react'
import PropTypes from 'prop-types'

import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'

import './VetrinaDigitaleSubmitPopup.scss'
import formattedMessage from './languageModule'

const VetrinaDigitaleSubmitPopup = (props) => (
  <Toggle>
    <MerchantModal
      ariaModalDescription={formattedMessage.ariaModalDescription}
      ariaModalTitle={formattedMessage.title}
      title={formattedMessage.title}
      description={formattedMessage.description}
      onClose={() => { }}
      primaryAction={() => location.replace(props.redirectUrl)}
      primaryButtonLabel={formattedMessage.primaryButtonLabel}
      primaryButtonIcon='link'
    />
  </Toggle>
)

VetrinaDigitaleSubmitPopup.propTypes = {
  /** Descrizione delle prop se necessario */
  redirectUrl: PropTypes.string
}

VetrinaDigitaleSubmitPopup.defaultProps = {
  /** Default values */
}

export default VetrinaDigitaleSubmitPopup
